import { config } from "./config";

// let bookings = {};
let bookings;
let lastUpdated;

export const bookingStates = {
    NONE: 0,
    MORNING: 1,
    EVENING: 2,
    MORNING_AND_EVENING: 3,
    FULL: 4,
}

export async function initializeBookings() {
    if (!lastUpdated) {
        const response = await fetch(config.bookingsDataUrl);
        const data = await response.json();
        console.log('Fetched booking data', {data});
        lastUpdated = data.updatedAt;
        bookings = data.bookings;
    }
}

export function getBookingState(date) {
    const time = Math.ceil(date.getTime() / 1000);
    return bookings[time] ?? bookingStates.NONE;
}

export function getLastUpdated() {
    const date = new Date(lastUpdated * 1000);
    return date.toLocaleDateString();
}
